import React from "react";

interface ChatsPageProps {
  children: React.ReactNode;
}

/** Custom layout for chats on desktop. */
const ChatsPage: React.FC<ChatsPageProps> = ({ children }) => {
  return <div className="md:col-span-12 lg:col-span-9">{children}</div>;
};

export default ChatsPage;
